import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../../../environments/environment';
import {DashboardGroupInfo} from '../models/dashboard-group-info.model';
import {AssetMetaDataPayload} from '../models/assets-meta-data.model'
import {Asset} from '../models/asset.model';


@Injectable({
    providedIn: 'root',
})

export class AssetApi {
    baseUrl = environment.baseUrl;
    api = environment.api;

    constructor(private http: HttpClient) {
    }

    makeNewDashboard(body: any): Observable<any> {
        return this.http.post<any>(`${this.api}/Dashboard/CreateDashboard`, body);
    }

    deleteAssets(body: any): Observable<any> {
        return this.http.post(`${this.api}/Asset/MultipleDelete`, body);
    }

    removeDashboardFromGroup(loadingAssets: any, dashboards: Asset[]): Observable<any> {
        const dashboardIds = [];
        dashboards.forEach(dashboard => dashboardIds.push(dashboard.assetId));
        const bodyRequest = {
            workspaceId: loadingAssets.workspaceId,
            dashboardGroupId: loadingAssets.dashboardGroupId,
            dashboardIds,
        };
        return this.http.post(`${this.api}/DashboardGroup/RemoveDashboardFromGroup`, bodyRequest);
    }

    updateDatasourceName(body: any): Observable<any> {
        return this.http.post(`${this.api}/DataSource/ChangeDataSourceName`, body);
    }

    updateDashboard(body: any): Observable<any> {
        return this.http.post(`${this.api}/Dashboard/UpdateDashboard`, body);
    }
    updateDashboardName(dahsbaord: any): Observable<any> {
        return this.http.post(`${this.api}/Dashboard/UpdateDashboardName`, dahsbaord);
      }
      
    updateDashboardGroup(body: any): Observable<any> {
        return this.http.post(`${this.api}/DashboardGroup/UpdateDashboardGroup`, body);
    }

    updateDataSourceInfo(body: any): Observable<any> {
        return this.http.post(`${this.api}/DataSource/UpdateDataSourceInfo`, body);
    }

    updateDatasourceData(body: any) {
        return this.http.post(`${this.api}/DataSource/UpdateDataSourceData`, body);
    }

    duplicateDatasource(workspaceId: string, dataSourceId: string): Observable<any> {
        return this.http.post(`${this.api}/DataSource/DuplicateDataSource`, {workspaceId, dataSourceId});
    }

    addDashboardToGroup(dashboardGroupInfo: DashboardGroupInfo, dashboardIds: string[]): Observable<any> {
        const bodyRequest = {
            workspaceId: dashboardGroupInfo.workspaceId,
            dashboardGroupId: dashboardGroupInfo.dashboardGroupId,
            dashboardIds,
        };
        return this.http.post(`${this.api}/DashboardGroup/AddDashboardToGroup`, bodyRequest);
    }

    createDashboardGroup(name: string, workspaceId: string): Observable<any> {
        const bodyRequest = {
            workspaceId,
            name,
        };
        return this.http.post(`${this.api}/DashboardGroup/CreateDashboardGroup`, bodyRequest);
    }


    deActiveDashboard(workspaceId: string, dashboardId: string): Observable<any> {
        return this.http.post(`${this.api}/Dashboard/DeactivateDashbaord/${workspaceId}/${dashboardId}`, null);
    }

    activeDashboard(workspaceId: string, dashboardId: string): Observable<any> {
        return this.http.post(`${this.api}/Dashboard/ActivateDashboard/${workspaceId}/${dashboardId}`, null);
    }


    addBookmark(asset: Asset): Observable<any> {
        const bodyRequest = {
            assetId: asset.assetId,
            assetType: asset.assetType,
            workspaceId: asset.workspaceId,
        };
        return this.http.post(`${this.api}/Bookmark/AddBookmark`, bodyRequest);
    }

    removeBookmark(asset: Asset): Observable<any> {
        const bodyRequest = {
            assetId: asset.assetId,
            assetType: asset.assetType,
            workspaceId: asset.workspaceId,
        };
        return this.http.post(`${this.api}/Bookmark/RemoveBookmark`, bodyRequest);
    }

    uploadFile(uploadType: string, formFile: FormData, workspaceId: string) {
        return this.http.post(`${this.api}/File/UploadImage/${uploadType}/${workspaceId}`, formFile);
    }

    getDashboardGroupsForMove(workspaceId: string, dashboardId: string): Observable<any> {
        const bodyRequest = {
            workspaceId,
            dashboardId,
        };
        return this.http.post(`${this.api}/DashboardGroup/GetDashboardGroupsForMove`, bodyRequest);
    }

    moveDashboardToGroup(workspaceId: string, dashboardGroupId: string, dashboardId: string): Observable<any> {
        const bodyRequest = {
            workspaceId,
            dashboardGroupId,
            dashboardId,
        };
        return this.http.post(`${this.api}/DashboardGroup/MoveDashboardToGroup`, bodyRequest);
    }

    getWelcomeMessage(workspaceId: string): Observable<any> {
      return this.http.post(`${this.api}/ApplicationSetting/GetUserWelcomeMessage`, { workspaceId });
    }

    duplicateDashboard(workspaceId: string, dashboardId: string, dashboardGroupId: string): Observable<any> {
        const bodyRequest = {
            workspaceId,
            dashboardId,
            dashboardGroupId,
        };
        return this.http.post(`${this.api}/Dashboard/DuplicateDashboard`, bodyRequest);
    }

    updateDashboardImage(workspaceId: string, dashboardId: string, imagePath: string): Observable<any> {
        const bodyRequest = {
            workspaceId,
            dashboardId,
            imagePath,
        };
        return this.http.post(`${this.api}/Dashboard/UpdateDashboardImage`, bodyRequest);
    }

    updateDataSourceImage(workspaceId: string, dataSourceId: string, imagePath: string): Observable<any> {
        const bodyRequest = {
            workspaceId,
            dataSourceId,
            imagePath,
        };
        return this.http.post(`${this.api}/DataSource/UpdateDataSourceImage`, bodyRequest);
    }

    updateDashboardGroupImage(workspaceId: string, id: string, imagePath: string): Observable<any> {
        const bodyRequest = {
            workspaceId,
            id,
            imagePath,
        };
        return this.http.post(`${this.api}/DashboardGroup/UpdateDashboardGroupImage`, bodyRequest);
    }

  getAssetsMetaData(bodyRequest: AssetMetaDataPayload): Observable<any> {
    return this.http.post(`${this.api}/Asset/GetAssetsMetadata`, bodyRequest);
  }

  getDashboardsGroupMetaData(workspaceId: string, dashboardGroupId: string): Observable<any> {
    return this.http.post(`${this.api}/Asset/GetDashboardGroupMetadata`, { workspaceId, dashboardGroupId });
  }

  updateDashboardPinStatus(dashboardId: string): Observable<any> {
    return this.http.post(`${this.api}/Dashboard/UpdateDashboardPinStatus/${dashboardId}`, {});
  }

  updateDashboardGroupPinStatus(dashboardGroupId: string): Observable<any> {
    return this.http.post(`${this.api}/DashboardGroup/UpdateDashboardGroupPinStatus/${dashboardGroupId}`, {});
  }
  exportDashboard(workspaceId: string, dashboardId: string):Observable<any>  {
    return this.http.post(
      `${this.api}/Dashboard/ExportDashboard`,
      { workspaceId, dashboardId }
    );
  }
}
